<template>
  <svg
    ref="rootRef"
    class="rays overflow-visible mix-blend-overlay"
    width="66.8747"
    height="66.8747"
    viewBox="0 0 66.8747 66.8747"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g class="rays-inner">
      <!-- 7 tapering rays laid out radially around the center (360/7°) -->
      <g v-for="(rot, i) in RAY_ROTATIONS" :key="i" :transform="rot">
        <path
          d="M29.9374 0.183683H36.9374L33.4373 19.1837L29.9374 0.183683Z"
          :fill="`url(#${gradId})`"
        />
      </g>
    </g>
    <defs>
      <!-- Ray is brightest at the outer end, fades toward the center (as in the mockup) -->
      <linearGradient
        :id="gradId"
        x1="33.4374"
        y1="0.183683"
        x2="33.4374"
        y2="19.1837"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
  import { ref, useId, watch } from 'vue';

  const props = defineProps<{ pulseKey?: number }>();

  const rootRef = ref<SVGSVGElement | null>(null);
  const gradId = `hotels-ray-${useId()}`;

  // 7 rays: the base one points up, the rest are rotated around the center (33.4374, 33.4374)
  const CENTER = 33.4374;
  const RAY_ROTATIONS = Array.from(
    { length: 7 },
    (_, i) => `rotate(${((i * 360) / 7).toFixed(4)} ${CENTER} ${CENTER})`,
  );

  // Restart the ray «burst» in sync with the icon (shared pulseKey)
  watch(
    () => props.pulseKey,
    () => {
      const el = rootRef.value;
      if (!el) return;
      el.classList.remove('is-playing');
      void el.getBoundingClientRect();
      el.classList.add('is-playing');
    },
  );
</script>

<style scoped>
  /* The whole ray cluster grows from the center and flies outward (each on its own path) */
  .rays-inner {
    transform-box: view-box;
    transform-origin: 50% 50%;
    opacity: 0;
  }
  .is-playing .rays-inner {
    /* same timing as the house (720ms): peak spread coincides with the icon's «peak» */
    animation: rays-burst 720ms cubic-bezier(0.22, 1, 0.36, 1) both;
  }
  @keyframes rays-burst {
    0% {
      /* appear at the center */
      transform: scale(0.25);
      opacity: 0;
    }
    30% {
      /* PEAK: fully spread and brightest — in sync with the house peak */
      transform: scale(1.05);
      opacity: 0.7;
    }
    60% {
      /* fly outward and fade */
      transform: scale(1.28);
      opacity: 0.32;
    }
    100% {
      transform: scale(1.5);
      opacity: 0;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .is-playing .rays-inner {
      animation: none !important;
    }
  }
</style>
